import createFormValueSelector from '../createFormValueSelector';
import immutable from '../structure/immutable';

export default createFormValueSelector(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/formValueSelector.js
// module id = 1193
// module chunks = 0